import { BrowserRouter, NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { ProveedorSesion, useSesion } from './sesion';
import { Cargando } from './componentes/comunes';
import Acceso from './paginas/Acceso';
import Clientes from './paginas/Clientes';
import Ordenes from './paginas/Ordenes';
import TotPagina from './paginas/Tot';
import Preventivo from './paginas/Preventivo';
import Almacen from './paginas/Almacen';
import Materiales from './paginas/Materiales';
import Compras from './paginas/Compras';
import { Operaciones, Direccion, Contabilidad } from './paginas/Egresos';
import Facturacion from './paginas/Facturacion';
import TarifasIguala from './paginas/TarifasIguala';
import Cobertura from './paginas/Cobertura';
import PreciosPreventivos from './paginas/PreciosPreventivos';
import Administracion, { subseccionesVisibles } from './paginas/Administracion';
import Catalogos from './paginas/Catalogos';
import Refacciones from './paginas/Refacciones';
import Proveedores from './paginas/Proveedores';
import Usuarios from './paginas/Usuarios';
import Roles from './paginas/Roles';
import Tecnicos from './paginas/Tecnicos';

/**
 * La aplicación ocupa la raíz del dominio. Los prototipos siguen en
 * /prototipos, que Nginx resuelve contra otra carpeta y por eso no choca
 * con el enrutado de aquí.
 */
export default function App() {
  return (
    <BrowserRouter>
      <ProveedorSesion>
        <Contenido />
      </ProveedorSesion>
    </BrowserRouter>
  );
}

function Contenido() {
  const { usuario, cargando, puede } = useSesion();

  if (cargando) return <Cargando que="Recuperando tu sesión…" />;
  if (!usuario) return <Acceso />;

  const hayAdministracion = subseccionesVisibles(puede).length > 0;

  return (
    <>
      <header className="barra">
        {/* El logo con su texto alternativo: si la imagen no carga —una
            caché vieja, un despliegue a medias— tiene que seguir viéndose
            de quién es el sistema. */}
        <img className="logo" src="/logo.png" alt="APRISA · Mantenimiento industrial" />

        <nav className="menu">
          {puede('ordenes', 'ver') && (
            <NavLink to="/ordenes" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Órdenes
            </NavLink>
          )}
          {/* El TOT vive junto a Órdenes porque de una orden cuelga
              siempre, pero tiene permiso propio desde la 0037. Usaba el
              de órdenes, y `ordenes.ver` lo tienen nueve roles —almacén
              surte contra una orden, compras compra para ella,
              facturación la cobra—: a todos les salía esta sección, que
              no les toca. */}
          {puede('tot', 'ver') && (
            <NavLink to="/tot" className={({ isActive }) => (isActive ? 'activo' : '')}>
              TOT
            </NavLink>
          )}
          {/* El programa del mes. Lo arma supervisión y lo consultan
              soporte y almacén: de aquí sale saber qué refacciones pedir
              con anticipación, que tardan más de treinta días. */}
          {puede('preventivo', 'ver') && (
            <NavLink to="/preventivo" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Preventivo
            </NavLink>
          )}
          {/* Almacén aparece con su permiso **o** con el de una de sus
              pestañas. Karin: «soporte operativo tiene que ver de almacen
              lo de surtido por tienda solamente».

              Es el único cambio de mecanismo que pidió esa idea, y vale
              para lo que venga: una sección se abre por pedazos dando un
              módulo a la pestaña, y el menú la enseña si le toca alguno.
              Quien sólo tiene el surtido entra y ve una sola pestaña. */}
          {(puede('almacen', 'ver') || puede('surtido_tienda', 'ver')) && (
            <NavLink to="/almacen" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Almacén
            </NavLink>
          )}
          {/* El otro inventario, con su propio permiso. Supervisión y
              soporte entran aquí y no a Almacén: piden material para sus
              técnicos y no tienen por qué ver el almacén entero. */}
          {puede('materiales', 'ver') && (
            <NavLink to="/materiales" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Materiales
            </NavLink>
          )}
          {puede('compras', 'ver') && (
            <NavLink to="/compras" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Compras
            </NavLink>
          )}
          {puede('operaciones', 'ver') && (
            <NavLink to="/operaciones" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Operaciones
            </NavLink>
          )}
          {puede('direccion', 'ver') && (
            <NavLink to="/direccion" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Dirección
            </NavLink>
          )}
          {puede('contabilidad', 'ver') && (
            <NavLink to="/contabilidad" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Contabilidad
            </NavLink>
          )}
          {puede('facturacion', 'ver') && (
            <NavLink to="/facturacion" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Facturación
            </NavLink>
          )}
          {puede('clientes', 'ver') && (
            <NavLink to="/clientes" className={({ isActive }) => (isActive ? 'activo' : '')}>
              Clientes
            </NavLink>
          )}
          {/* Cobranza no aparece a propósito. El módulo existe en el
              esquema y en los permisos, pero APRISA no lo va a usar por
              ahora: enseñar una sección vacía sólo genera preguntas. */}
          {hayAdministracion && (
            <NavLink
              to="/administracion"
              className={({ isActive }) => (isActive ? 'activo' : '')}
            >
              Administración
            </NavLink>
          )}
          {/* Los prototipos no van en el menú. Son referencia de diseño
              con datos inventados, y hasta ahora se le ofrecían a
              cualquiera que entrara —incluido un supervisor de zona, que
              no tiene por qué toparse con pantallas que no son el
              sistema—. Siguen publicados en /prototipos/ para quien los
              necesite, y sólo en QA: producción no los publica. */}
        </nav>

        <Identidad />
      </header>

      <main>
        <Routes>
          <Route path="/administracion" element={<Administracion />}>
            <Route path="catalogos" element={<Catalogos />} />
            <Route path="refacciones" element={<Refacciones />} />
            <Route path="proveedores" element={<Proveedores />} />
            <Route path="tarifas-iguala" element={<TarifasIguala />} />
            <Route path="precios-preventivos" element={<PreciosPreventivos />} />
            <Route path="cobertura" element={<Cobertura />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="roles" element={<Roles />} />
            <Route path="tecnicos" element={<Tecnicos />} />
          </Route>

          <Route path="/ordenes" element={<Ordenes />} />
          <Route path="/tot" element={<TotPagina />} />
          <Route path="/preventivo" element={<Preventivo />} />
          <Route path="/almacen" element={<Almacen />} />
          <Route path="/materiales" element={<Materiales />} />
          <Route path="/compras" element={<Compras />} />
          <Route path="/operaciones" element={<Operaciones />} />
          <Route path="/direccion" element={<Direccion />} />
          <Route path="/contabilidad" element={<Contabilidad />} />
          <Route path="/facturacion" element={<Facturacion />} />
          <Route path="/clientes" element={<Clientes />} />

          {/* Las rutas de la primera versión, cuando cada sección colgaba
              de la raíz. Se conservan para no romper enlaces guardados. */}
          <Route path="/catalogos" element={<Navigate to="/administracion/catalogos" replace />} />
          <Route path="/refacciones" element={<Navigate to="/administracion/refacciones" replace />} />
          <Route path="/proveedores" element={<Navigate to="/administracion/proveedores" replace />} />

          {/* La raíz lleva a lo que el perfil use a diario. */}
          <Route
            path="*"
            element={
              <Navigate
                to={
                  // Dirección primero: quien tiene esa pantalla la usa
                  // como su inicio, y mandarlo a Órdenes lo obliga a
                  // navegar cada vez que entra.
                  puede('direccion', 'ver') ? '/direccion'
                    : puede('ordenes', 'ver') ? '/ordenes'
                      : puede('clientes', 'ver') ? '/clientes'
                        : '/administracion'
                }
                replace
              />
            }
          />
        </Routes>
      </main>
    </>
  );
}

function Identidad() {
  const { usuario, salir } = useSesion();

  return (
    <div className="usuario">
      <span>
        {usuario?.nombre}
        {usuario?.roles.length ? ` · ${usuario.roles.join(', ')}` : ''}
      </span>
      <button onClick={() => void salir()}>Salir</button>
    </div>
  );
}
